// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3jG7L","buttons":"RemoveExpirationActionButtons_buttons__Fy5M6"};